/** @jsx jsx */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import theme from '../../gatsby-plugin-theme-ui'
import Body from '../shared/Typography/Body/Body'
import { jsx, Box, Grid, IconButton, Flex } from 'theme-ui'
import Button from '../shared/Buttons/Button'
import Textarea from '../shared/Textarea/Textarea'
import Input from '../shared/Input/Input'
import times from '../../icons/times.svg'
import CustomStarRating from '../shared/StarRating/StarRating'
import { useModal } from 'react-modal-hook'
import Modal from '../shared/Modal/Modal'
import styled from '@emotion/styled'
import { useWindowSize } from '../../hooks/useWindowSize'

/*
  ⚠️ This is an example of a contact form powered with Netlify form handling.
  Be sure to review the Netlify documentation for more information:
  https://www.netlify.com/docs/form-handling/
*/

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

const Logo = styled.img`
  width: 12px;
`

const ReviewForm = props => {
  const { mobile } = useWindowSize()
  const [values, setValues] = useState({ name: '', email: '', rating: 0 })
  const [showModal, hideModal] = useModal(() => (
    <Modal
      isOpen={showModal}
      onRequestClose={hideModal}
      hideModal={hideModal}
      style={{
        content: {
          width: '500px',
          height: '180px',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'block',
          bottom: 'auto',
        },
      }}
    >
      <Flex sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <Body variant="body2">Your review has been submitted, thank you!</Body>
      </Flex>
    </Modal>
  ))

  const handleRatingChange = rating => {
    setValues({ ...values, rating })
  }

  const handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    setValues({ ...values, [name]: value })
  }

  const handleSubmit = event => {
    fetch('/?no-cache=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'reviewForm', ...values }),
    })
      .then(handleSuccess)
      .catch(error => alert(error))
    event.preventDefault()
  }

  const handleSuccess = () => {
    setValues({ name: '', email: '', rating: 0 })
    showModal()
  }

  return (
    <form
      variant="reviewForm"
      name="reviewForm"
      onSubmit={handleSubmit}
      data-netlify="true"
      data-netlify-honeypot="bot"
      sx={{
        mb: '20px',
        mt: '20px',
      }}
    >
      <input type="hidden" name="bot-field" />
      <input type="hidden" name="product" value={props.productName} />
      <input type="hidden" name="form-name" value="reviewForm" />
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: '20px',
        }}
      >
        <Body variant="body3">WRITE A REVIEW</Body>

        <IconButton sx={{ p: '0' }} onClick={props.hidden}>
          <Logo src={times} />
        </IconButton>
      </Flex>

      <Body variant="body2" sx={{ display: 'inline', mr: '5px' }}>
        Rating
      </Body>
      <CustomStarRating
        rating={values.rating}
        changeRating={handleRatingChange}
        name="reviewFormRating"
        starDimension="15px"
      />

      <Grid
        gap={2}
        columns={[1, null, 2]}
        sx={{
          my: '10px',
        }}
      >
        <Input
          sx={{
            background: '#ffffff',
          }}
          name="name"
          type="text"
          placeholder="Name"
          value={values.name}
          onChange={handleInputChange}
          required
        />
        <Input
          sx={{
            background: '#ffffff',
          }}
          name="email"
          type="email"
          placeholder="Email Address"
          value={values.email}
          onChange={handleInputChange}
          required
        />
      </Grid>

      <Textarea
        sx={{
          color: 'black',
          margin: '0 0 1em 0',
        }}
        name="review"
        type="text"
        placeholder="Review..."
        value={values.review}
        onChange={handleInputChange}
        required
        rows={5}
      />

      <Flex
        sx={{
          justifyContent: 'flex-end',
        }}
      >
        <Button
          name="submit"
          type="submit"
          value="Submit"
          variant="default"
          sx={{
            height: '48px',

            width: ['100%', null, '10%'],
          }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Flex>
    </form>
  )
}

ReviewForm.propTypes = {
  data: PropTypes.object,
}

export default ReviewForm
